import { useMemo } from 'react';

import type { RelevancyCardFormat } from '../types';

export const useCardFormatCheck = (cardFormat: RelevancyCardFormat) => {
  const isWide = useMemo(() => cardFormat?.startsWith('wide') ?? true, [cardFormat]);
  const isPortrait = useMemo(() => cardFormat?.startsWith('portrait'), [cardFormat]);
  const isSquareOver = useMemo(() => cardFormat?.startsWith('square-over'), [cardFormat]);
  const isSquareUnder = useMemo(() => cardFormat?.startsWith('square-under'), [cardFormat]);
  const imgFormat = useMemo(() => {
    if (isSquareOver || isSquareUnder) return ['0@s1'];
    return isPortrait ? ['0@p1'] : ['0@w1'];
  }, [isPortrait, isSquareOver, isSquareUnder]);

  const aspectRatio: '1:1' | '9:16' | '16:9' = useMemo(() => {
    if (isSquareOver) return '1:1';
    return isPortrait ? '9:16' : '16:9';
  }, [isSquareOver, isPortrait]);

  return {
    isWide,
    isPortrait,
    isSquareOver,
    isSquareUnder,
    imgFormat,
    aspectRatio,
  };
};
